import React, { useEffect, useState } from "react";
import SoftwareCard from "./SoftwareCard";
import { fetchSoftwareList } from "../api";

function SoftwareList({ refreshKey, showAdmin, onDelete }) {
  const [softwareData, setSoftwareData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSoftware = async () => {
      setLoading(true);
      setError("");
      try {
        const data = await fetchSoftwareList();
        setSoftwareData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSoftware();
  }, [refreshKey]);

  if (loading) {
    return (
      <div className="rs-loading">
        <div className="rs-spinner" />
        <p>Yazılımlar yükleniyor...</p>
      </div>
    );
  }

  if (error) {
    return <div className="rs-alert rs-alert--danger">{error}</div>;
  }

  return (
    <>
      <h2 className="rs-section-title">
        {showAdmin ? "Yazılım Listesi (Yönetim Modu)" : "Mevcut Yazılımlar"}
      </h2>
      {showAdmin && (
        <p
          style={{
            fontSize: "0.85rem",
            color: "var(--rs-gray-600)",
            margin: "-0.75rem 0 1.25rem",
          }}
        >
          Silmek istediğiniz yazılımın kartındaki &quot;Sil&quot; butonunu
          kullanın.
        </p>
      )}
      <div className="row g-4">
        {softwareData.map((software, index) => (
          <div className="col-md-6 col-lg-4" key={`${software.name}-${index}`}>
            <SoftwareCard
              software={software}
              index={index}
              showAdmin={showAdmin}
              onDelete={onDelete}
            />
          </div>
        ))}
      </div>
    </>
  );
}

export default SoftwareList;
